export const Context = {
    "unit": "Easy Systems",
    "environment": "estest",
    "cleanEnv": "test",
    "baseUrl": "https://test.gateway.easysystems-cloud.com",
    "appUrl": "https://apptest.gateway.easysystems-cloud.com/",
    "ssoUrl": "",
    "apikey": "",
    "region": "eu-west-1",
    "buckedPrefix": "apigateway"
}